import axios from '@/helpers/axios';

export default async function graphqlFetch({ query, variables, graphqlUrl }) {
  const { data: { data, errors } } = (
    await axios.post(graphqlUrl, { query, variables })
  );
  if (errors) {
    console.error(errors); // eslint-disable-line no-console
    return null;
  }
  return data;
}
